'use client'

import { zodResolver } from '@hookform/resolvers/zod'
import { useTranslations } from 'next-intl'
import { useForm } from 'react-hook-form'

import { TSignIn, createZSignIn } from '@/entities/auth'
import { Link } from '@/shared/i18n'
import { Button, Form } from '@/shared/ui'

import { useSignIn } from '../../api/sign-in'

const defaultValues: TSignIn = {
  username: '',
  password: '',
  rememberMe: false,
}

export const SignInForm = () => {
  const t = useTranslations('login')

  const form = useForm<TSignIn>({
    resolver: zodResolver(createZSignIn(t)),
    defaultValues,
    mode: 'onBlur',
    reValidateMode: 'onBlur',
  })

  const signIn = useSignIn(form)

  const submitForm = (data: TSignIn) => {
    signIn.execute(data)
  }

  return (
    <Form.Root form={form}>
      <Form.Field name="username">
        <Form.Label className="font-medium text-black">
          {t('email_label')}
        </Form.Label>
        <Form.TextField
          type="email"
          placeholder={t('email_placeholder')}
          fullWidth
          autoComplete="username"
        />
        <Form.Message />
      </Form.Field>
      <Form.Field name="password" className="mt-6">
        <Form.Label className="font-medium text-black">
          {t('password_label')}
        </Form.Label>
        <Form.PasswordField
          placeholder={t('password_placeholder')}
          fullWidth
          autoComplete="on"
        />
        <Form.Message className="whitespace-break-spaces" />
      </Form.Field>

      <div className="mt-4 flex items-center justify-between">
        <Form.Field name="rememberMe">
          <Form.Checkbox size="small">{t('auto_login')}</Form.Checkbox>
        </Form.Field>
      </div>

      <Button
        size="large"
        className="mt-10 mb-2.5"
        type="submit"
        fullWidth
        onClick={form.handleSubmit(submitForm)}
      >
        {t('button.login')}
      </Button>

      <Button asChild variant="outline" size="large" fullWidth>
        <Link href="/sign-up">{t('button.sign_up')}</Link>
      </Button>
    </Form.Root>
  )
}
